import { Component } from '@angular/core';
import { SvgIconComponent } from '@utilities/components/svg-icon/svg-icon.component';
import { RouterLink } from '@angular/router';
import { ShowFeatureDirective } from '../../../shared/directives/show-feature.directive';
import { Feature } from '../../../shared/enums/feature.enum';

@Component({
  selector: 'app-footer',
  imports: [RouterLink, ShowFeatureDirective],
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  Feature = Feature;
}
